"use client";
import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";
import {getStaticPathIcon} from "@/shared/utils/get-static-path-icon";

import {type DateRangePickerTriggerProps} from "../../daterange-picker-field";

import "./styles/daterange-filter-trigger.scss";

export function DateRangeFilterTrigger(props: DateRangePickerTriggerProps): JSX.Element {
    const {startDate, endDate, startPlaceholder, endPlaceholder, disabled, hasValue, onClick, onClear} = props;

    const formatDate = (date: Date | null): string => {
        if (!date) return "";
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };

    return (
        <div className="daterange-filter-trigger-wrapper">
            <button type="button" onClick={onClick} disabled={disabled} className="daterange-filter-trigger">
                <div className="daterange-filter-trigger__date">
                    <SmartImage
                        width={50}
                        height={50}
                        src={getStaticPathIcon("calendar")}
                        alt="Calendar"
                        className="daterange-filter-trigger__icon"
                    />
                    <Typography as="span" size={14} weight={400} color="title" className="daterange-filter-trigger__value">
                        {startDate ? formatDate(startDate) : startPlaceholder}
                    </Typography>
                </div>

                <div className="daterange-filter-trigger__date">
                    <SmartImage
                        width={50}
                        height={50}
                        src={getStaticPathIcon("calendar")}
                        alt="Calendar"
                        className="daterange-filter-trigger__icon"
                    />
                    <Typography as="span" size={14} weight={400} color="title" className="daterange-filter-trigger__value">
                        {endDate ? formatDate(endDate) : endPlaceholder}
                    </Typography>
                </div>
            </button>

            {hasValue && !disabled && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onClear();
                    }}
                    className="daterange-filter-trigger__clear"
                    aria-label="Clear dates"
                >
                    ×
                </button>
            )}
        </div>
    );
}
